import { AbstractEntity } from '../AbstractEntity'

export class USCommodityCode extends AbstractEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
  }
  get code() {
    return this._data.code
  }
  set code(code) {
    this._data.code = code
  }
  get remark() {
    return this._data.remark
  }
  set remark(remark) {
    this._data.remark = remark
  }
  get commodityName() {
    return this._data.commodityName
  }
  set commodityName(commodityName) {
    this._data.commodityName = commodityName
  }
  get hsCode() {
    return this._data.hsCode
  }
  set hsCode(hsCode) {
    this._data.hsCode = hsCode
  }
  get commodityDescription() {
    return this._data.commodityDescription
  }
  set commodityDescription(commodityDescription) {
    this._data.commodityDescription = commodityDescription
  }
  get descriptionCode() {
    return this._data.descriptionCode
  }
  set descriptionCode(descriptionCode) {
    this._data.descriptionCode = descriptionCode
  }
  get status() {
    return this._data.status
  }
  set status(status) {
    if (typeof status === 'number') {
      this._data.status = status
    } else {
      this._data.status = 1
    }
  }
  get customsRate() {
    return this._data.customsRate
  }
  set customsRate(customsRate) {
    this._data.customsRate = customsRate || 0
  }
  get customsRateAmount() {
    return this._data.customsRateAmount
  }
  set customsRateAmount(customsRateAmount) {
    this._data.customsRateAmount = customsRateAmount || 0
  }
  get chinaAdditionalTaxRule() {
    return this._data.chinaAdditionalTaxRule
  }
  set chinaAdditionalTaxRule(chinaAdditionalTaxRule) {
    this._data.chinaAdditionalTaxRule = chinaAdditionalTaxRule
  }
  get additionalRate056() {
    return this._data.additionalRate056
  }
  set additionalRate056(additionalRate056) {
    this._data.additionalRate056 = additionalRate056 || 0
  }
  get containAdditionalTax499() {
    return this._data.containAdditionalTax499
  }
  set containAdditionalTax499(containAdditionalTax499) {
    if (typeof containAdditionalTax499 === 'boolean') {
      this._data.containAdditionalTax499 = containAdditionalTax499
    } else {
      this._data.containAdditionalTax499 = true
    }
  }
  get containAdditionalTax501() {
    return this._data.containAdditionalTax501
  }
  set containAdditionalTax501(containAdditionalTax501) {
    if (typeof containAdditionalTax501 === 'boolean') {
      this._data.containAdditionalTax501 = containAdditionalTax501
    } else {
      this._data.containAdditionalTax501 = true
    }
  }
  get chinaHongKongAdditionalTaxRule() {
    return this._data.chinaHongKongAdditionalTaxRule
  }
  set chinaHongKongAdditionalTaxRule(chinaHongKongAdditionalTaxRule) {
    this._data.chinaHongKongAdditionalTaxRule = chinaHongKongAdditionalTaxRule
  }
}
